const addSwipeEvent = (window, document) => {
  if (typeof window.CustomEvent !== 'function') {
    window.CustomEvent = function (event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined,
      };

      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(
        event,
        params.bubbles,
        params.cancelable,
        params.detail,
      );
      return evt;
    };

    window.CustomEvent.prototype = window.Event.prototype;
  }

  //   let { swipeThreshold = 20, swipeTimeout = 500 } = options;

  //   if (isNaN(swipeTimeout) || typeof swipeTimeout !== 'number')
  //     swipeTimeout = 500;

  //   if (isNaN(swipeThreshold) || typeof swipeTimeout !== 'number')
  //     swipeTimeout = 20;
  let startEl = null;
  let scroollTop = 0;

  let initX = 0;
  let initY = 0;
  let diffX = 0;
  let diffY = 0;
  let moveX = 0;
  let moveY = 0;
  let dirX = 1;
  let dirY = 1;
  let timeDown = 0;
  let started = false;
  let transform = '';
  let transition = '';

  const handleTouchEnd = e => {
    started = false;
    dirX = e.changedTouches[0].screenX - initX;
    dirY = e.changedTouches[0].screenY - initY;
    startEl.dispatchEvent(
      new CustomEvent('swipe', {
        bubbles: true,
        cancelable: true,
        detail: {
          moveY,
          moveX,
          dirX,
          dirY,
          diffX,
          diffY,
          ended: true,
          started: true,
          transform,
          transition,
          scroollTop,
        },
      }),
    );
    initX = 0;
    initY = 0;
    dirX = 1;
    dirY = 1;
    moveX = 0;
    moveY = 0;
    diffX = 0;
    diffY = 0;
    transform = '';
    transition = '';
  };

  const handleTouchMove = e => {
    if (!started) return;
    moveY = e.changedTouches[0].screenY - diffY;
    moveX = e.changedTouches[0].screenX - diffX;
    dirX = e.changedTouches[0].screenX - initX;
    dirY = e.changedTouches[0].screenY - initY;
    startEl.dispatchEvent(
      new CustomEvent('swipe', {
        bubbles: true,
        cancelable: true,
        detail: {
          moveY,
          moveX,
          dirX,
          dirY,
          diffX,
          diffY,
          ended: false,
          started: true,
          transform,
          transition,
          scroollTop,
        },
      }),
    );
  };

  const handleTouchStart = e => {
    scroollTop = document.documentElement.scrollTop || document.body.scrollTop;
    startEl = e.target.closest('.slider') || e.target;
    const startTime = Date.now();
    if (startTime - timeDown < 500) return;
    timeDown = startTime;
    started = true;
    initX = e.changedTouches[0].screenX;
    initY = e.changedTouches[0].screenY;

    const { transform: a, transition: b } = window.getComputedStyle(startEl);
    const { currentX, currentY } = a.match(
      /matrix\((?:-*\d+,\s){4}(?<currentX>-*\d+),\s(?<currentY>-*\d+)/,
    )?.groups || { currentX: '0', currentY: '0' };
    transform = a;
    transition = b;
    diffX = initX - parseInt(currentX, 10);
    diffY = initY - parseInt(currentY, 10);
    startEl.dispatchEvent(
      new CustomEvent('swipe', {
        bubbles: true,
        cancelable: true,
        detail: {
          moveY,
          moveX,
          dirX,
          dirY,
          diffX,
          diffY,
          ended: false,
          started: false,
          transform,
          transition,
          scroollTop,
        },
      }),
    );
  };

  document.addEventListener('touchstart', handleTouchStart, false);
  document.addEventListener('touchmove', handleTouchMove, false);
  document.addEventListener('touchend', handleTouchEnd, false);
};

export default addSwipeEvent;
